<div class="container-fluid">
    <div class="main-wrapper">
        <app-header></app-header>
        <app-side-bar></app-side-bar>
        <router-outlet></router-outlet>
    </div>
</div>